/* 

*/

import ExcelenciaCentro from "pages/CentroExcelencia";

export default function CentroExcelenciaPage() {
  return <ExcelenciaCentro />;
}
